import $ from 'jquery';
import Swiper from 'swiper';
import * as YandexLoader from 'ymaps';
import SelectService from '../service/SelectService';
import HistoryManager from '../util/HistoryManager';

const getSlideIndexByClass = (className) => {
    return $(`.services-items-slider .swiper-slide.${className}`).index();
};

const createServicesSlider = () => {
    window.servicesSlider = new Swiper('.services-items .swiper-container', {
        direction: 'vertical',
        speed: 600,
        spaceBetween: 20,
        slidesPerView: 'auto',
        autoHeight: true,
        navigation: {
            nextEl: '.services-items-slider__button--next',
            prevEl: '.services-items-slider__button--prev',
        },
    });
};

const filterSliderItems = (itemIds) => {
    $('.services-items-slider .swiper-wrapper').children().each((index, item) => {
        if (itemIds.includes($(item).attr('data-id'))) {
            $(item).removeClass('non-swiper-slide').addClass('swiper-slide').attr('style', null)
                .show();
        } else {
            $(item).addClass('non-swiper-slide').removeClass('swiper-slide')
                .hide();
        }
        setTimeout(() => {
            window.servicesSlider.update();
        }, 50);
    });
};

createServicesSlider();

window.servicesSlider.on('click', () => {
    window.servicesSlider.update();
});

YandexLoader.default.load('https://api-maps.yandex.ru/2.1/?apikey=08c8d65a-b50d-4915-97ad-f06875a6d428&lang=ru_RU').then((ymaps) => {
    if (!(typeof window.mapMarkers === 'undefined')) {
        const markersRawJson = window.mapMarkers;
        const featureCollection = [];
        Object.keys(markersRawJson).forEach((key) => {
            const item = markersRawJson[key];
            const itemObject = {
                type: 'Feature',
                geometry: {
                    type: 'Point',
                    coordinates: [item.lat, item.lng]
                },
                properties: {
                    // iconContent: '',
                    hintContent: `${item.name}, ${item.city}`,
                    ...item
                },
                options: {
                    preset: 'islands#redIcon'
                }
            };
            featureCollection.push(itemObject);
        });


        ymaps.ready(function () {
            const myMap = new ymaps.Map('services-map', {
                center: [55.73, 37.75],
                zoom: 9,
                controls: ['zoomControl']
            }, {
                searchControlProvider: 'yandex#search'
            });

            window.myObjects = ymaps.geoQuery({
                type: 'FeatureCollection',
                features: featureCollection
            }).addEvents('click', function (e) {
                // eslint-disable-next-line
                const data = e.originalEvent.target.properties._data;
                $('.services-item-additionally').hide();
                window.servicesSlider.slideTo(getSlideIndexByClass(`services-item--${data.id}`));
            }).addToMap(myMap);

            myMap.setBounds(myMap.geoObjects.getBounds());

            const selectRegionOnCountryUpdate = (value) => {
                const { dom } = SelectService.getControl('services-region');
                if (value === false) {
                    dom.options.addClass('control-select-option--hidden');
                } else {
                    dom.options.addClass('control-select-option--hidden')
                        .filter(`.control-select-option--section-${value}`)
                        .removeClass('control-select-option--hidden');
                }
            };

            const selectCityOnRegionUpdate = (value) => {
                const { dom } = SelectService.getControl('services-city');
                if (value === false) {
                    dom.options.addClass('control-select-option--hidden');
                } else {
                    dom.options.addClass('control-select-option--hidden')
                        .filter(`.control-select-option--section-${value}`)
                        .removeClass('control-select-option--hidden');
                }
            };

            selectRegionOnCountryUpdate(SelectService.getValue('services-country'));
            selectCityOnRegionUpdate(SelectService.getValue('services-region'));

            SelectService.onChange('services-country', (value) => {
                selectRegionOnCountryUpdate(value);
                SelectService.setValue('services-region', false);
            });

            SelectService.onChange('services-region', (value) => {
                selectCityOnRegionUpdate(value);
                SelectService.setValue('services-city', false);
            });

            const getFilterParameters = () => {
                const parameters = HistoryManager.current().getParameters();

                const country = SelectService.getValue('services-country');
                if (country) {
                    parameters.country = country;
                }

                const region = SelectService.getValue('services-region');
                if (region) {
                    parameters.region = region;
                }

                const city = SelectService.getValue('services-city');
                if (city) {
                    parameters.city = city;
                }

                return parameters;
            };

            let firstLoad = true;
            $('.filter--services').submit(function (event) {
                event.preventDefault();
                setTimeout(() => {
                    const parameters = getFilterParameters();
                    if (firstLoad) {
                        firstLoad = false;
                        if (!parameters.country) {
                            return;
                        }
                    }

                    let resultObjects;
                    let byCountry = new ymaps.GeoQueryResult();
                    let byRegion = new ymaps.GeoQueryResult();
                    let byCity = new ymaps.GeoQueryResult();

                    if (parameters.country) {
                        byCountry = window.myObjects.search(`properties.country='${parameters.country}'`).add(byCountry);
                        resultObjects = byCountry;
                    }
                    if (parameters.region) {
                        byRegion = window.myObjects.search(`properties.region='${parameters.region}'`).add(byRegion);
                        resultObjects = resultObjects.intersect(byRegion);
                    }
                    if (parameters.city) {
                        byCity = window.myObjects.search(`properties.city='${parameters.city}'`).add(byCity);
                        resultObjects = resultObjects.intersect(byCity);
                    }

                    setTimeout(() => {
                        if (!(typeof resultObjects === 'undefined')) {
                            resultObjects.addToMap(myMap);
                            window.myObjects.remove(resultObjects).removeFromMap(myMap);
                        } else {
                            window.myObjects.removeFromMap(myMap).addToMap(myMap);
                        }
                        myMap.setBounds(
                            myMap.geoObjects.getBounds(),
                            { checkZoomRange: true },
                        ).then(() => {
                            if (myMap.getZoom() > 14) {
                                myMap.setZoom(14);
                            }
                        });
                    }, 1);

                    setTimeout(() => {
                        const sliderFilterIds = [];

                        myMap.geoObjects.each((item) => {
                            // eslint-disable-next-line
                            sliderFilterIds.push(item.properties._data.id);
                        });
                        if (!(typeof window.servicesSlider === 'undefined')) {
                            filterSliderItems(sliderFilterIds);
                        }
                    }, 500);
                }, 1);
            });

            $('.filter--services').submit();

            $('body').on('click', '.services-item', function () {
                $('.services-item-additionally').hide();
                $(this).find('.services-item-additionally').show();
                const storeId = $(this).attr('data-id');
                const searchById = window.myObjects.search(`properties.id='${storeId}'`);
                // eslint-disable-next-line
                const data = searchById._objects[0].properties._data;
                myMap.setCenter([data.lat, data.lng], 10, {
                    checkZoomRange: true
                });
            });
        });
    }
});
